module.exports = __webpack_public_path__ + "static/img/ico_cos_mo.6807a84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010111/ico_cos_mo.png
// module id = uUBy
// module chunks = 10